module.exports = __webpack_public_path__ + "img/logo-lg.5ef64162.svg";